import {createRouter, createWebHistory} from 'vue-router';
import CompaniesAdmin from "@/features/companies/admin/CompaniesAdmin.vue";
import DemoAdmin from "@/views/admin/DemoAdmin.vue";
import NotFound from "@/components/NotFound.vue";

const routes = [
    {
        path: '/v',
        name: 'app',
        children: []
    },
    {
        path: '/adminv1',
        name: 'AdminPage',
        redirect: '/adminv1/companies',
        children: [
            {
                path: 'companies',
                component: CompaniesAdmin
            },
            {
                path: 'demo',
                component: DemoAdmin
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*', // catch-all pattern
        name: 'NotFound',
        component: NotFound
    }


];

// Show routes in browser, requires backend fallback to handle the routes on refresh
const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;